import { NgTemplateOutlet } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { SupportEnvironment } from '../support-environment'
import { SupportLinkResolver, SupportResource } from '../support-link.resolver'

/**
 * Content is captured into a template and stamped by both branches: a second <ng-content> would be a
 * separate slot, and only the first one would ever receive the projected nodes.
 */
@Component({
  selector: 'app-support-link',
  standalone: true,
  imports: [RouterLink, NgTemplateOutlet],
  template: `
    <ng-template #content><ng-content></ng-content></ng-template>
    @if (link.routerLink !== null) {
      <a [routerLink]="link.routerLink" queryParamsHandling="merge" [class]="linkClass" [style.background-color]="backgroundColor">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    } @else {
      <a [href]="link.href" target="_blank" rel="noopener" [class]="linkClass" [style.background-color]="backgroundColor">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    }
  `,
  // The host is a pass-through so that wrapping an anchor in this component cannot change the
  // layout of the cell it sits in.
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SupportLinkComponent {
  private resolver = inject(SupportLinkResolver)

  @Input()
  environment: SupportEnvironment | undefined = undefined

  @Input({ required: true })
  resource!: SupportResource

  @Input({ required: true })
  id!: number

  @Input()
  linkClass = ''

  @Input()
  backgroundColor: string | null = null

  get link() {
    return this.resolver.linkTo(this.environment, this.resource, this.id)
  }
}
